import {
    createAdmin,
    reinviteAdmin,
    getAdminById,
    getAdmins,
    changeAdminStatus,
    editAdminById,
    createCredential,
    getCredential,
    editCredentialById,
    deleteCredentialById,
    getEmployment,
    createEmployment,
    getPayCode,
    editEmployment,
    createPayCode,
    createStaffService,
    getStaffService,
    deleteStaffService,
    isClinician,
    getTimesheet,
    createTimesheet,
    getAllAdmins,
    editPayCode,
    getTimesheetById,
    editTimesheet,
    terminatePayCode,
    getAllPayCodes,
    clearAllPayCodes,
    createAdminDetails,
    removeTimesheetById,
    deleteEmployment,
    uploadAvatar,
    getBasicAdmins,
    getBasicActiveAdmins,
    deletePayCode,
    removeAdminById,
    getStaffFsServices,
    editStaffPassword,
    getAssignedStaffClients,
    assignClientToStaff,
    editAssignClientFromStaff,
    unAssignClientToStaff,
    createStaffSignature,
    deleteStaffSignature,
    changeTelehealthStatus,
    assignZoomAccount,
    getStaffSupervisionSummary,
} from './admin.action';

export { adminReducer } from './admin.reducer';
export { watchAdmin } from './admin.saga';

export const adminActions = {
    /** Staff */
    createAdmin,
    editStaffPassword,
    reinviteAdmin,
    createAdminDetails,
    getAdmins,
    getAllAdmins,
    getBasicAdmins,
    getBasicActiveAdmins,
    getAdminById,
    removeAdminById,
    changeAdminStatus,
    changeTelehealthStatus,
    assignZoomAccount,
    editAdminById,
    uploadAvatar,

    /** End */

    /** Staff Credentials */
    createCredential,
    getCredential,
    editCredentialById,
    deleteCredentialById,
    /** End */

    /** Staff Employment */
    getEmployment,
    createEmployment,
    editEmployment,
    deleteEmployment,
    /** End */

    /** Staff PayCodes */
    getPayCode,
    createPayCode,
    terminatePayCode,
    editPayCode,
    deletePayCode,
    getAllPayCodes,
    clearAllPayCodes,
    /** End */

    /** Staff Service */
    createStaffService,
    getStaffFsServices,
    getStaffService,
    deleteStaffService,
    /** End */

    isClinician,
    getTimesheet,
    getTimesheetById,
    removeTimesheetById,
    createTimesheet,
    editTimesheet,

    /** Staff Assignment */
    assignClientToStaff,
    unAssignClientToStaff,
    editAssignClientFromStaff,
    getAssignedStaffClients,
    /** End */

    /** Staff Signature */
    createStaffSignature,
    deleteStaffSignature,
    /** End */

    /** Staff Supervision Summary */
    getStaffSupervisionSummary,
    /** End */
};
